import { jsx as _jsx } from "react/jsx-runtime";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { useMemo } from "react";
import { BankAccountCurrency } from "@bundles/UIAppBundle/collections/BankAccounts/enum";
import { useTranslate } from "@bluelibs/x-ui";
ChartJS.register(ArcElement, Tooltip, Legend);
const PieChart = ({ title, colors, labels, labelResolver, data, extendedData, className, }) => {
    const t = useTranslate();
    const getBarChartOptions = useMemo(() => ({
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: "top",
            },
            title: {
                display: true,
                text: title,
            },
            tooltip: {
                callbacks: {
                    footer: (ctx) => {
                        var _a, _b;
                        return `${t("charts.totalAmount")}: ${((_b = (_a = extendedData === null || extendedData === void 0 ? void 0 : extendedData[0]) === null || _a === void 0 ? void 0 : _a[ctx[0].dataIndex]) !== null && _b !== void 0 ? _b : 0).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })} ${BankAccountCurrency.RON}`;
                    },
                },
            },
        },
    }), [extendedData, title]);
    const getPieChartData = useMemo(() => ({
        labels,
        datasets: Array.from({ length: data.length }).map((_, index) => {
            const pieColors = Array.from({ length: data[index].length }).map((_, index) => colors[index]);
            return {
                label: labelResolver
                    ? labelResolver(data, labels, index)
                    : labels[index],
                data: data[index],
                borderColor: pieColors,
                backgroundColor: pieColors,
            };
        }),
    }), [labels, data]);
    return (_jsx(Doughnut, { className: className, data: getPieChartData, options: getBarChartOptions }, void 0));
};
export default PieChart;
